export function predictSelectionType(source, sources) {
	const sourcePredictions = [
		"managedContactsContacts",
		"managedContactsManagers",
		"managedManageGroupManagers",
		"manageGroups",
		"managedWorkflows",
		"workflows",
		"managedForms",
		"forms"
	];

	sources = (sources || []).concat(source ? [source] : []);
	for (const source of sources) {
		if (sourcePredictions.includes(source)) {
			return `inaccessible.${source}`;
		}
	}
	return `inaccessible.fallback`;
}